import { cn } from '@/lib/cn';

/**
 * Real "Rachele Dolcezze" logo (transparent PNG cut from her brand).
 * `light` flips it to white for use over the dark hero photo.
 * Set the height via className (e.g. h-10).
 */
export function Logo({ className, light = false }: { className?: string; light?: boolean }) {
  return (
    <img
      src="/images/brand/logo.png"
      alt="Rachele Dolcezze"
      className={cn('w-auto select-none', className)}
      style={light ? { filter: 'brightness(0) invert(1)' } : undefined}
    />
  );
}
